'use strict';

const checkCarouselLength = (carouselContainer) => {
    if (!carouselContainer || typeof carouselContainer !== 'string') {
        return;
    }

    if ($(carouselContainer).length > 0) {
        $(carouselContainer).each(function () {
            const carousel = $(this);
            let carouselWidth = parseInt($(carousel).outerWidth());
            let carouselItemsNumber = $(carousel).children().length;
            let carouselItemsWidth = parseInt(
                $(carousel).children().outerWidth(),
            );
            let carouselItemsWidthSum =
                carouselItemsWidth * carouselItemsNumber;
            if (carouselItemsWidthSum + 16 <= carouselWidth) {
                $(this)
                    .closest('.cc-em')
                    .find('.cc-em__carouselCustom__arrows')
                    .hide();
                $(this).addClass('cc-em__carouselCustom_center');
            } else {
                $(this)
                    .closest('.cc-em')
                    .find('.cc-em__carouselCustom__arrows')
                    .show();
                $(this).removeClass('cc-em__carouselCustom_center');
            }

            $(this).scroll(function () {
                carouselWidth = parseInt($(carousel).outerWidth());
                carouselItemsNumber = $(carousel).children().length;
                carouselItemsWidth = parseInt(
                    $(carousel).children().outerWidth(),
                );
                carouselItemsWidthSum =
                    carouselItemsWidth * carouselItemsNumber;
                let carouselScrolled = $(carousel).scrollLeft();

                if (carouselScrolled < 1) {
                    $(carousel)
                        .closest('.cc-em')
                        .find('.js-carouselCustom__arrowLeft')
                        .addClass('cc-disabled');
                } else if (
                    carouselScrolled >=
                    carouselItemsWidthSum - carouselWidth + 16
                ) {
                    $(carousel)
                        .closest('.cc-em')
                        .find('.js-carouselCustom__arrowRight')
                        .addClass('cc-disabled');
                } else {
                    $(carousel)
                        .closest('.cc-em')
                        .find('.js-carouselCustom__arrowLeft')
                        .removeClass('cc-disabled');
                    $(carousel)
                        .closest('.cc-em')
                        .find('.js-carouselCustom__arrowRight')
                        .removeClass('cc-disabled');
                }
            });
        });
    }
};
$(document).ready(function () {
    // Custom Carousel
    function carouselScroll (el, dir) {
        const carousel = $(el).closest('.cc-em').find('.cc-em__carouselCustom');
        const carouselItemsWidth = parseInt(
            $(carousel).children().outerWidth(),
        );
        let carouselScrolled = $(carousel).scrollLeft();

        if (dir === 'right') {
            $(carousel).scrollLeft(carouselScrolled + carouselItemsWidth);
        } else {
            $(carousel).scrollLeft(carouselScrolled - carouselItemsWidth);
        }
    }

    $(document).on('click', '.js-carouselCustom__arrowLeft', function () {
        carouselScroll(this, 'left');
    });

    $(document).on('click', '.js-carouselCustom__arrowRight', function () {
        carouselScroll(this, 'right');
    });
    $('body').on('common:checkCarouselLength', function (e, data) {
        if (!data || !data.name) {
            return;
        }
        checkCarouselLength(data.name);
    });
});

export { checkCarouselLength };
